import { MapTo } from '@adobe/aem-react-editable-components';
import ArticleAnchorModule, { ArticleAnchorModuleEditConfig } from './ArticleAnchorModule';

export default MapTo('cob-corp-acquisition/components/creditonebank/article-anchor-module')(ArticleAnchorModule, ArticleAnchorModuleEditConfig);